import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MadCapImageUrlModule } from '@portal-core/general/pipes/madcap-image-url/madcap-image-url.module';
import { LicenseUserAvatarTooltipClassModule } from '@portal-core/license-users/pipes/license-user-avatar-tooltip-class/license-user-avatar-tooltip-class.module';
import { LicenseUserAvatarTooltipModule } from '@portal-core/license-users/pipes/license-user-avatar-tooltip/license-user-avatar-tooltip.module';
import { AvatarIndicatorModule } from '@portal-core/ui/avatar/directives/avatar-indicator/avatar-indicator.module';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { LicenseUserAvatarComponent } from './license-user-avatar.component';

@NgModule({
  imports: [
    AvatarIndicatorModule,
    CommonModule,
    InlineButtonModule,
    LicenseUserAvatarTooltipClassModule,
    LicenseUserAvatarTooltipModule,
    MadCapImageUrlModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule
  ],
  declarations: [
    LicenseUserAvatarComponent
  ],
  exports: [
    AvatarIndicatorModule,
    LicenseUserAvatarComponent
  ]
})
export class LicenseUserAvatarModule { }
